import { useMutation } from 'react-query';

import { forgotPassword as mutationFn } from 'api/endPoints/forgotPassword';

export const useMutationForgotPassword = () => {
    return useMutation<unknown, QueryError, { email: string }>({ mutationFn });
};
